exports.install = function (Vue, options) {
	//获取地址
	Vue.prototype.getaddress = function(value={})
	{
		return this.axiosget("/api/address/area",value)
		.then((response)=>{
			return response;
		})
	};
}